import { render, staticRenderFns } from "./SwitchBasic.vue?vue&type=template&id=531109a2&"
import script from "./SwitchBasic.vue?vue&type=script&lang=js&"
export * from "./SwitchBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports